import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { FeatureSection } from './components/FeatureSection';
import { DashboardPreview } from './components/DashboardPreview';
import { BenefitsSection } from './components/BenefitsSection';
import { Footer } from './components/Footer';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AIAssistantPage } from './pages/AIAssistantPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={<LoginPage data-id="element-3" />} data-id="element-2" />
        <Route path="/app" element={<DashboardPage data-id="element-5" />} data-id="element-4" />
        <Route path="/app/ai-assistant" element={<AIAssistantPage data-id="element-7" />} data-id="element-6" />
        <Route path="/" element={<div className="flex flex-col min-h-screen w-full bg-gray-50" data-id="element-9">
              <header className="w-full bg-white shadow-sm sticky top-0 z-10" data-id="element-10">
                <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-11">
                  <div className="flex items-center space-x-2" data-id="element-12">
                    <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-13">
                      <span className="text-white font-bold" data-id="element-14">T</span>
                    </div>
                    <span className="text-xl font-bold text-gray-800" data-id="element-15">
                      TaxTidy
                    </span>
                  </div>
                  <nav className="hidden md:flex space-x-8" data-id="element-16">
                    <a href="#features" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-17">
                      Funktionen
                    </a>
                    <a href="#dashboard" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-18">
                      Dashboard
                    </a>
                    <a href="#benefits" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-19">
                      Vorteile
                    </a>
                  </nav>
                  <div className="flex space-x-4 items-center" data-id="element-20">
                    <Link to="/login" className="hidden md:block text-gray-700 hover:text-blue-600 font-medium" data-id="element-21">
                      Anmelden
                    </Link>
                    <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition font-medium" data-id="element-22">
                      Kostenlos testen
                    </button>
                  </div>
                </div>
              </header>
              <main className="flex-grow" data-id="element-23">
                <HeroSection data-id="element-24" />
                <FeatureSection data-id="element-25" />
                <DashboardPreview data-id="element-26" />
                <BenefitsSection data-id="element-27" />
              </main>
              <Footer data-id="element-28" />
            </div>} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}